
































import { Component, Vue } from 'vue-property-decorator'

import { Action, State } from 'vuex-class'

import { ConfirmLeaveModal, OrderPaymentFiltersForm } from '@/components'

import { MobileLayout } from '@/layouts/components'

import {
  ModalState,
  OrderPaymentFilters,
  OrderPaymentPageQuery
} from '@/models'

import { RootState } from '@/store/state'

import { isSetsEqual, normalizeDate } from '@/utils'

@Component({
  components: {
    ConfirmLeaveModal,
    MobileLayout,
    OrderPaymentFiltersForm
  }
})
export default class ChangeOrderPaymentFilters extends Vue {
  confirmLeaveState = new ModalState()

  defaultFilters: OrderPaymentFilters = {}

  data: OrderPaymentFilters | null = null
  isValid = false

  get hasChanges () {
    return this.data !== null && !this.compareFilters(this.data, this.query)
  }

  get isClear () {
    return this.data !== null && this.compareFilters(this.data, this.defaultFilters)
  }

  @State((state: RootState) => state.ordering.orderPayments.query)
  readonly query!: OrderPaymentPageQuery

  @Action('ordering/changeOrderPaymentFilter')
  changeFilters!: (params: { filters: OrderPaymentFilters; isDefaultFilters: boolean }) => Promise<void>

  @Action('ordering/loadOrderPaymentPage')
  loadOrderPaymentPage!: () => Promise<void>

  async reload () {
    try {
      await this.loadOrderPaymentPage()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async clearFilters () {
    await this.changeFilters({
      filters: this.defaultFilters,
      isDefaultFilters: true
    })

    this.goBack()
  }

  async handleSubmit () {
    if (this.data === null || !this.hasChanges || !this.isValid) {
      return
    }

    await this.changeFilters({
      filters: {
        startDate: normalizeDate(this.data.startDate ?? '') ?? undefined,
        endDate: normalizeDate(this.data.endDate ?? '') ?? undefined,
        status: this.data.status
      },
      isDefaultFilters: this.isClear
    })
    await this.reload()
    this.goBack()
  }

  handleGoBack () {
    if (this.hasChanges) {
      this.confirmLeaveState.isActive = true
    } else {
      this.goBack()
    }
  }

  goBack () {
    this.$router.back()
  }

  compareFilters (a: OrderPaymentFilters, b: OrderPaymentFilters): boolean {
    return (
      (a.startDate === b.startDate || (!a.startDate && !b.startDate)) &&
      (a.endDate === b.endDate || (!a.endDate && !b.endDate)) &&
      isSetsEqual(new Set(a.status), new Set(b.status))
    )
  }
}
